import * as angular from "angular";

angular
  .module('bringoz.admin.ai-agents')
  .config(aiAgentsConfig);

/* @ngInject */
function aiAgentsConfig($stateProvider) {

  $stateProvider

    // Teams
    .state('ai-agents', {
      parent: 'bringoz.site',
      url: '/ai-agents',
      template: '<ai-agents-view></ai-agents-view>',
      controller: function ($scope, triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "AI Agents"});
        triBreadcrumbsService.addCrumb({name: "Automations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

}
